module.exports = __webpack_public_path__ + "static/img/card.85789506.png";